<template>
  <b-modal title="Display de Protocolo" v-model="show" size="xl">
    <div id="arquivoDeProtocolo">
      <b-img :src="preview == null ? require('/static/images/default.png') : preview" class="rounded-0" fluid />
    </div>
    <template #modal-footer>
      <b-button variant="primary" v-print="'#arquivoDeProtocolo'">Imprimir</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";

export default {
  name: "DisplayDeProtocoloModal",

  data() {
    return {
      show: false,
      preview: null,
    };
  },

  methods: {
    call(image) {
      const reader = new FileReader();
      const blob = new Blob([image]);
      reader.readAsDataURL(blob);
      reader.onload = (e) => {
        this.preview = e.target.result;
        this.show = !this.show;
      };
    },
  },

  setup() {
    const store = useSgcqStore();
    return {
      store,
    };
  },
};
</script>

<style lang="scss" scoped></style>
